import { render, staticRenderFns } from "./consolidation.vue?vue&type=template&id=6047d728&scoped=true"
import script from "./consolidation.vue?vue&type=script&lang=js"
export * from "./consolidation.vue?vue&type=script&lang=js"
import style0 from "./consolidation.vue?vue&type=style&index=0&id=6047d728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6047d728",
  null
  
)

export default component.exports